/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

export default [
  [
    ['полунощ', 'сутринта', 'на обед', 'следобед', 'вечерта', 'през нощта'], ,
    ['полунощ', 'сутринта', 'на обяд', 'следобед', 'вечерта', 'през нощта']
  ],
  [
    ['полунощ', 'сутринта', 'на обед', 'следобед', 'вечерта', 'през нощта'],
    ,
  ],
  [
    '00:00', ['04:00', '11:00'], ['11:00', '14:00'], ['14:00', '18:00'], ['18:00', '22:00'],
    ['22:00', '04:00']
  ]
];
